import Icon from '../components/Icon.vue'

Icon.register({
  crutch: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M507.3 185.7c2.6 2.6 4.6 7.6 4.6 11.3 0 3.7-2.1 8.7-4.7 11.3l-22.6 22.6c-2.6 2.6-7.7 4.7-11.3 4.7-3.7 0-8.7-2.1-11.3-4.7l-181-181c-2.6-2.6-4.7-7.7-4.7-11.3s2.1-8.7 4.7-11.3l22.7-22.6c2.6-2.6 7.7-4.7 11.3-4.7s8.7 2.1 11.3 4.7zM327.8 252.1l55.1-55.1 45.3 45.3-109.7 109.7c-10.7 10.7-31.5 22.2-46.3 25.6l-120.3 27.8-102 102c-2.6 2.6-7.7 4.7-11.3 4.7s-8.7-2.1-11.3-4.7l-22.6-22.6c-2.6-2.6-4.7-7.7-4.7-11.3s2.1-8.7 4.7-11.3l102-102 27.7-120.3c3.4-14.8 14.9-35.5 25.7-46.3l109.7-109.7 45.3 45.3-55.1 55.1zM273.2 306.7l9.3-9.3-67.9-67.9-9.3 9.3c-3.6 3.6-7.4 10.5-8.6 15.5l-18.3 79.3 79.3-18.3c4.9-1.1 11.9-5 15.5-8.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/crutch.js
// module id = 1251
// module chunks = 0